import {createApp} from 'vue'
import router from './router'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// Dark mode（2026-06）：Element Plus 官方暗色变量 + 应用级变量层 + 模式管理。
// 激活方式均为 <html class="dark">，由 initTheme()/useTheme 切换。
import 'element-plus/theme-chalk/dark/css-vars.css'
import './styles/theme.css'
import {initTheme} from './composables/useTheme'
// Shared pill-button baseline used by the watchlist component family
// (WatchlistButton, WatchlistUndoToast) and admin.vue's row action
// buttons. Imported globally so all consumers — including those mounted
// outside of WatchlistButton.vue's scoped style — share the same height,
// radius, and colour modifiers. See gupiao_frontend/src/styles/wl-buttons.css.
import './styles/wl-buttons.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

initTheme()

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(router).use(ElementPlus);
app.mount('#app')
